import { Colors, Icon, Spacer, Tag, FloatingBox, Typography, } from '@zapier/design-system';
import InAppSidebarSubheaderButton from './InAppSidebarSubheaderButton';
import { Fragment, useRef, useState } from 'react';
import { css, jsx } from '@emotion/react';
import { useUniversalNavContext } from '../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
import { baseReset, boxSizing } from '../../../../utils/style-mixins/reset';
const MENU_WIDTH = '240px';
const MenuStyles = css(Object.assign(Object.assign({}, boxSizing), { display: 'flex', flexDirection: 'column', maxHeight: 'inherit', boxSizing: 'border-box', overflow: 'auto', padding: 'var(--zds-space-8)', width: MENU_WIDTH, left: '3px', top: '30px', outline: 'none' }));
const MenuItemStyles = css(Object.assign(Object.assign({}, baseReset), { display: 'flex', gap: 'var(--zds-space-12)', padding: 'var(--zds-space-8)', borderRadius: '4px', cursor: 'pointer', position: 'relative', alignItems: 'center', '&:focus-visible, &:hover': {
        backgroundColor: 'var(--zds-ui-brand-weakest)',
    }, '&:focus-visible': {
        outline: 'var(--zds-border-focus)',
        outlineOffset: 'var(--zds-space-2)',
    } }));
const IconWrapperStyles = (isActive) => css(Object.assign(Object.assign({}, boxSizing), { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--zds-space-8)', borderRadius: 'var(--zds-radius-small)', backgroundColor: isActive
        ? 'var(--zds-ui-brand-weakest)'
        : 'var(--zds-background-strong)', '& svg': {
        fill: isActive ? `${Colors.BrandOrange}` : 'var(--zds-text-default)',
    } }));
const TitleWrapperStyles = css(Object.assign(Object.assign(Object.assign({}, baseReset), Typography.Body1), { color: 'var(--zds-text-default)' }));
const DescriptionWrapperStyles = css(Object.assign(Object.assign(Object.assign({}, baseReset), Typography.MinimalPrint1), { color: 'var(--zds-text-weaker)' }));
const CreationItem = ({ description, href, icon, iconFilled, id, tag, target, title, }) => {
    const [isActive, setIsActive] = useState(false);
    const { getFullyQualifiedURL } = useUniversalNavContext();
    return (jsx("a", { css: MenuItemStyles, href: getFullyQualifiedURL(href), id: id, target: target, onFocus: () => setIsActive(true), onBlur: () => setIsActive(false), onMouseEnter: () => setIsActive(true), onMouseLeave: () => setIsActive(false), onClick: () => {
            emitUserInteractionEvent({
                event_action: 'click',
                option_selected: `UniversalSidebar CreateDropdown: ${title}`,
            });
        }, "data-zds": true },
        jsx("div", { "data-zds": true, css: IconWrapperStyles(isActive) },
            jsx(Icon, { name: isActive ? iconFilled : icon, size: 20, shouldAnimateFill: false })),
        jsx("div", { css: {
                display: 'flex',
                flexDirection: 'column',
            }, "data-zds": true },
            jsx("div", { css: { display: 'flex', alignItems: 'center' }, "data-zds": true },
                jsx("span", { "data-zds": true, css: TitleWrapperStyles }, title),
                tag && (jsx(Fragment, null,
                    jsx(Spacer, { width: 8 }),
                    jsx(Tag, { size: "small", variant: "simple" }, tag)))),
            jsx("span", { "data-zds": true, css: DescriptionWrapperStyles }, description))));
};
export const CreateDropdown = ({ items }) => {
    const { isCreateMenuOpen, setIsCreateMenuOpen } = useUniversalNavContext();
    const buttonRef = useRef(null);
    return (jsx("div", { ref: buttonRef, style: { position: 'relative' }, "data-zds": true },
        jsx(InAppSidebarSubheaderButton, { iconName: "formAdd", onClick: (event) => {
                event.stopPropagation();
                emitUserInteractionEvent({
                    event_action: 'click',
                    option_selected: `UniversalSidebar CreateDropdown ${isCreateMenuOpen ? 'close' : 'open'}`,
                });
                setIsCreateMenuOpen(!isCreateMenuOpen);
            }, text: "Create" }),
        isCreateMenuOpen && (jsx(FloatingBox, { borderColor: "transparent", borderRadius: "medium", maxWidth: MENU_WIDTH, onClickOutside: (event) => {
                if (buttonRef &&
                    buttonRef.current &&
                    !buttonRef.current.contains(event.target))
                    setIsCreateMenuOpen(false);
            } },
            jsx("div", { css: MenuStyles, "data-zds": true }, items.map((item) => (jsx(CreationItem, Object.assign({}, item, { key: item.id })))))))));
};
//# sourceMappingURL=CreateDropdown.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
